// extracted by mini-css-extract-plugin
export default {"root":"Ljusu","saveArea":"NJ1I3","save":"W2MZR","selected":"_5KSxM","disabled":"mtJU0","mainCycleBox":"nzMQy","title":"wkwsx","price":"e60C2","aMonth":"RTJMu"};